jQuery(document).ready(function($) {

  /* ACCORDION SCRIPTS ------------------------------------------ */
  $('.wp-block-singular.accordion-container').each(function() {

    var $accordion = $(this);

    $('.accordion-item', $accordion).each(function() {

      var $item = $(this);
      var $title_wrap = $('.accordion-item-title > div', $item);
      var $content_wrap = $('.accordion-item-content', $item);
      var $content_content = $('> div', $content_wrap);

      var toggle_code = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 72" role="img" aria-label="Accordion Item Toggle">
        <title>Accordion Item Toggle</title>
        <g data-name="Desktop Arrow Down" transform="translate(1307.369 -416.5) rotate(90)">
          <path id="Line_4" data-name="Line 4" d="M64.886,4.225H0V-1.5H64.886Z" transform="translate(416.5 1284.415)" fill="#ba1f3b"/>
          <path id="Line_6" data-name="Line 6" d="M5.725,30.535H0V0H5.725Z" transform="translate(484.616 1281.729) rotate(45)" fill="#ba1f3b"/>
          <path id="Line_7" data-name="Line 7" d="M5.725,30.535H0V0H5.725Z" transform="translate(488.664 1285.778) rotate(135)" fill="#ba1f3b"/>
        </g>
      </svg>`;

      $title_wrap.append('<button class="toggle"><span>'+toggle_code+'</span></button>').on('click', function() {
        
        if ($item.hasClass('open')) {

          $content_wrap.css('max-height','');
          $item.removeClass('open');

        } else {

          var content_height = $content_content.innerHeight() + 'px';
          $content_wrap.css('max-height',content_height);
          $item.addClass('open');

        }

      });

    });

    $(window).on('resize', function() {

      $('.accordion-item.open').each(function() {

        var $content_wrap = $('.accordion-item-content', this);
        var $content_content = $('> div', $content_wrap);
        var content_height = $content_content.innerHeight() + 'px';
        $content_wrap.css('max-height',content_height);

      });

    });

  });

});
